// API Configuration
// Use environment variable if available.
// For local development on localhost, default to local API.
// Otherwise fall back to production API.
const isLocalhost = typeof window !== 'undefined' && (
	window.location.hostname === 'localhost' ||
	window.location.hostname === '127.0.0.1'
);

export const API_BASE_URL =
	(isLocalhost
		? 'http://localhost:5000'
		: (process.env.REACT_APP_API_URL || 'https://api.betbuilder.com.au'));
